// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6689 ? "b536a0f1" : chunkId) + "." + {"574":"bd573dc84b2f1cfc","2188":"28095d34f0b136a9","6689":"9ebd1304a8ae2770","7689":"5960412240db17ae","9431":"535944656992d94e","9931":"0deeaa9e52e3c84b"}[chunkId] + ".js";
};